module.exports = __webpack_public_path__ + "img/red-1-oval-striped.51b97fd9.svg";